import { createTextarea } from '@gluestack-ui/textarea';
import { Root, Input } from './styled-components';
const AccessibleTextarea = createTextarea({
    Root,
    Input,
});
export const Textarea = AccessibleTextarea;
export const TextareaInput = AccessibleTextarea.Input;
